import { createFileRoute } from "@tanstack/react-router";
import SaintTmsInsuranceCoverage from "@/pages/SaintTmsInsuranceCoverage";
import { buildHreflang } from "@/lib/i18n/locale";
export const Route = createFileRoute("/saint-tms-insurance-coverage")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS Insurance Coverage Guide | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Does insurance cover SAINT TMS? Learn about commercial plans, Medicare, and free benefits verification at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS Insurance Coverage Guide | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Does insurance cover SAINT TMS? Learn about commercial plans, Medicare, and free benefits verification at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-tms-insurance-coverage",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-tms-insurance-coverage",
        },
        ...buildHreflang("/saint-tms-insurance-coverage"),
      ],
    };
  },
});
function RouteComponent() {
  return <SaintTmsInsuranceCoverage />;
}
